import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-MN1QLKKPNS';

/**
 * AnalyticsTracker listens to route changes and triggers
 * Google Analytics (GA4) page_view events on SPA transitions.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Wait a tick to allow Helmet to update document.title
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('config', GA_MEASUREMENT_ID, {
          page_path: location.pathname + location.search,
          page_title: document.title,
          page_location: window.location.href,
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
